import { render } from "./SetNewPassword.vue?vue&type=template&id=c8606648&ts=true"
import script from "./SetNewPassword.vue?vue&type=script&lang=ts"
export * from "./SetNewPassword.vue?vue&type=script&lang=ts"

import "./SetNewPassword.vue?vue&type=style&index=0&id=c8606648&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__